import { makeStyles } from '@material-ui/core';
import { Colors } from '../../layout/theme-next';

export default makeStyles(theme => ({
  numberingValidationMessage: {
    marginTop: theme.spacing(-1),

    '& p': {
      margin: 0,
      marginBottom: theme.spacing(1.5),
    },
    '& code': {
      fontFamily: 'consolas, monospace',
      background: Colors.fieldDisabled,
      borderRadius: 4,
      padding: theme.spacing(0.25, 0.75),
      minWidth: 16,
    },
  },
  numberingValidationOptions: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1, 1),
    marginTop: theme.spacing(),
  },
  numberingValidationOption: {
    border: `1px solid ${Colors.fieldDisabled}`,
    borderRadius: 8,
    padding: theme.spacing(1),
    gap: theme.spacing(1, 1),
    display: 'flex',
    cursor: 'pointer',

    '&:hover': {
      background: Colors.primaryHighlight,
    },
  },
  numberingValidationOptionSelected: {
    borderColor: Colors.primaryLight,
    background: Colors.primaryHighlight,
  },
  numberingValidationOptionValue: {
    display: 'inline-block',
    marginLeft: theme.spacing(1),
    width: 128,

    '& input': {
      '-moz-appearance': 'textfield',

      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0,
      },
    },
  },
  numberingValidationOptionText: {
    flex: 1,
    lineHeight: 2.25,
  },
  numberingValidationOptionIcon: {
    margin: theme.spacing(0.75, 0, 0, 0),
    color: Colors.textDisabled,
  },
  numberingValidationOptionIconSelected: {
    color: Colors.primaryLight,
  },
  numberingValidationMessageExample: {
    fontSize: 12,
    lineHeight: 1,
    color: Colors.textDisabled,
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(1),
    borderTop: `1px solid ${Colors.stroke}`,
  },
}));
